<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconiconfont-kemu-copy"></i>
      考试列表
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center condition-warpper">
          <!--          <el-input-->
          <!--              v-model="keyword"-->
          <!--              placeholder="请输入考试名称"-->
          <!--              class="margin-right-xs"-->
          <!--          ></el-input>-->
          <!--          <el-date-picker-->
          <!--              class="margin-right-xs"-->
          <!--              v-model="time"-->
          <!--              type="daterange"-->
          <!--              range-separator="至"-->
          <!--              start-placeholder="开始日期"-->
          <!--              end-placeholder="结束日期">-->
          <!--          </el-date-picker>-->
          <!--          <el-select v-model="status" placeholder="请选择状态" class="margin-right-xs">-->
          <!--            <el-option label="全部" value=""></el-option>-->
          <!--            <el-option label="启用" value="1"></el-option>-->
          <!--            <el-option label="停用" value="0"></el-option>-->
          <!--          </el-select>-->
          <!--          <el-button type="primary" @click="onSearch">-->
          <!--            <p class="flex align-center font-size">-->
          <!--              <i class="el-icon-search margin-right-xs"></i>搜索-->
          <!--            </p>-->
          <!--          </el-button>-->
        </div>
        <router-link to="/projectOffice/examEdit">
          <el-button type="primary">
            <p class="flex align-center font-size">
              <i class="iconfont iconxinzeng margin-right-xs"></i>添加考试
            </p>
          </el-button>
        </router-link>
      </div>
      <div class="table-warpper">
        <el-table
            :data="examList"
            header-row-class-name="table-header"
            row-class-name="table-row"
            alig="center"
            fit
            style="width: 100%"
        >
          <el-table-column label="考试名称" width="200">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="考试时间" width="200">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.exam_start_time }}
                <br/>
                {{ scope.row.exam_end_time }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="科目" width="200">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.subject_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="报名截止时间" width="200">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.enroll_end_time }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态" fixed="right" width="60">
            <template slot-scope="scope">
              <div class="status-box">
                <el-switch
                    v-model="scope.row.state"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                </el-switch>
                <div class="status-click" @click="setItemStatus(scope.row.id,scope.row.state)"></div>
              </div>

            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="450">
            <template slot-scope="scope">
              <div class="table-operate flex align-center flex-wrap">
                <el-button
                    size="small"
                    type="primary"
                    @click="editItem(scope.row.id)"
                >编辑
                </el-button>
                <el-button
                    size="small"
                    type="primary"
                    @click="toExamCenter(scope.row.id)"
                >考场
                </el-button>
                <el-button
                    size="small"
                    type="primary"
                    @click="releaseItem(scope.row.id)"
                >发布考试
                </el-button>
                <el-button
                    v-if="scope.row.release === 1"
                    size="small"
                    type="primary"
                    @click="inviteItem(scope.row.id)"
                >邀请报名
                </el-button>
                <el-button
                    v-if="scope.row.release === 1"
                    size="small"
                    type="primary"
                    @click="paperItem(scope.row.id,scope.row.paper_type)"
                >试卷列表
                </el-button>
                <el-button
                    style="margin-left: 0"
                    class="margin-top-xs"
                    v-if="scope.row.release === 1"
                    size="small"
                    type="primary"
                    @click="sginItem(scope.row.id,scope.row.name)"
                >签到列表
                </el-button>
                <el-button
                    class="margin-top-xs"
                    v-if="scope.row.release === 1"
                    size="small"
                    type="primary"
                    @click="statisticsItem(scope.row.id,scope.row.paper_type,scope.row.name)"
                >分数统计
                </el-button>
                <el-button
                    class="margin-top-xs"
                    v-if="scope.row.release === 1"
                    size="small"
                    type="primary"
                    @click="orderItem(scope.row.id)"
                >订单对比
                </el-button>
                <el-button
                    :class="scope.row.release === 1?'margin-top-xs':''"
                    size="small"
                    type="danger"
                    @click="deleteItem(scope.row.id)"
                >删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            v-if="examList.length > 0"
            class="page-all"
            background
            :current-page.sync="page"
            :page-size="limit"
            layout="prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <release-dialog
        :setId="setId"
        :subdialogDialog="releaseDialog"
        @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>
import {examList, delExam} from "@/api/projectOffice";
import releaseDialog from "@/views/projectOffice/page/dialog/releaseDialog";

export default {
  name: "examination",
  components: {releaseDialog},
  data() {
    return {
      keyword: "",
      time: '',
      status: 1,
      examList: [],
      page: 1,
      total: 0,
      limit: 10,
      setId: 0,
      releaseDialog: false
    };
  },
  created() {
    this.$emit(
        "setIndex",
        this.$route.path,
        "当前位置：考试管理",
        false
    );
    if (this.$route.query.page) {
      this.page = Number(this.$route.query.page)
    }
    this.getList();
  },
  methods: {
    async getList() {
      let _list = await examList(
          this.page,
          this.limit,
          this.status,
      );
      _list.data.list.map(item => {
        item.state = item.state ? true : false
        item.exam_start_time = this.$tools.ZHDate(new Date(item.exam_start_time * 1000), 1)
        item.exam_end_time = this.$tools.ZHDate(new Date(item.exam_end_time * 1000), 1)
      })
      this.examList = _list.data.list;

      this.total = _list.data.count;
    },
    setPath() {
      this.$router.push({
        path: '/projectOffice/examination',
        query: {
          page: this.page,
        }
      })
    },
    editItem(id) {
      this.$router.push('/projectOffice/examEdit?id=' + id)
    },
    setItemStatus(id, state) {
      this.$confirm("确定要修改考试状态吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureSet(id, state);
      });
    },
    async sureSet(id, state) {
      let _state = await delExam(id, state ? 0 : 1);
      this.getList();
      this.$message.success(_state.msg);
    },
    deleteItem(id) {
      this.$confirm("确定要删除考试吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await delExam(id, -1);
      if (this.examList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getList();
      this.$message.success(_state.msg);
    },
    onSearch() {
      this.page = 1;
      this.getList();
    },
    toExamCenter(id) {
      this.$router.push('/projectOffice/examCenter?id=' + id)
    },
    releaseItem(id) {
      this.setId = Number(id)
      this.releaseDialog = true
    },
    inviteItem(id) {
      this.$router.push('/projectOffice/examInvite?id=' + id)
    },
    paperItem(id, paper) {
      this.$router.push('/projectOffice/examPaper?id=' + id + '&paper=' + paper)
    },
    sginItem(id, name) {
      this.$router.push('/projectOffice/examSgin?id=' + id + '&exam_name=' + name)
    },
    statisticsItem(id,paper,name) {
      this.$router.push('/projectOffice/examStatistics?id=' + id+ '&paper=' + paper + '&name=' + name)
    },
    orderItem(id) {
      this.$router.push('/projectOffice/examOrder?id=' + id)
    },
    cancelDialog(val) {
      this.getList()
      this.setId = 0
      this.releaseDialog = false
    }
  },
  watch: {
    page() {
      this.setPath()
    },
    $route() {
      this.getList();
    }
  }
}
</script>

<style scoped lang="scss">
.status-box {
  position: relative;

  .status-click {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>